module.exports = __webpack_public_path__ + "static/img/30020 (5).884de0b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30020 (5).webp
// module id = 6lqx
// module chunks = 14